export default "__VITE_ASSET__rLqYT0Pd__"